// utils
import { _val } from 'app/utils';

export const prescriptionProcedureKitInitFormFn = (values = {}) => {
  return {
    kits: _val(values.kits, []),
    padPrescriptionMatMeds: _val(values.padPrescriptionMatMeds, [])
  };
};
